// extracted by mini-css-extract-plugin
export var dataCell = "_q6-2";
export var dataRow = "_q6-0";
export var headerRow = "_q6-1";